import React from "react";
import { V2ReportStyle } from "../../styles/V2ReportStyle";

const SimpleLoader = () => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  };

  return (
    <div style={containerStyle}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={V2ReportStyle.spinnerStyle} />
    </div>
  );
};

export default SimpleLoader;
